export const stickers = [
  {
    title: 'pepe',
    items: [
      '/assets/sticker/pepe/1.png',
      '/assets/sticker/pepe/2.png',
      '/assets/sticker/pepe/3.png',
      '/assets/sticker/pepe/4.png',
      '/assets/sticker/pepe/5.png',
      '/assets/sticker/pepe/6.png',
      '/assets/sticker/pepe/7.png',
      '/assets/sticker/pepe/8.png',
      '/assets/sticker/pepe/9.png',
      '/assets/sticker/pepe/10.png',
      '/assets/sticker/pepe/11.png',
      '/assets/sticker/pepe/12.png',
      '/assets/sticker/pepe/13.png',
      '/assets/sticker/pepe/14.png',
      '/assets/sticker/pepe/15.png',
    ],
  },
  {
    title: 'wojak',
    items: [
      '/assets/sticker/wojak/1.png',
      '/assets/sticker/wojak/2.png',
      '/assets/sticker/wojak/3.png',
      '/assets/sticker/wojak/4.png',
      '/assets/sticker/wojak/5.png',
      '/assets/sticker/wojak/6.png',
      '/assets/sticker/wojak/7.png',
      '/assets/sticker/wojak/8.png',
      '/assets/sticker/wojak/9.png',
    ],
  },
  {
    title: 'other',
    items: [
      '/assets/sticker/other/1.png',
      '/assets/sticker/other/2.png',
      '/assets/sticker/other/3.png',
      '/assets/sticker/other/4.png',
      '/assets/sticker/other/5.png',
      '/assets/sticker/other/6.png',
      '/assets/sticker/other/7.png',
      '/assets/sticker/other/8.png',
    ],
  },
]
